export const sliderProductsNPR = [
  {
    locale : "en-US",
    productKey : "prd-zoew7b7u",
    priceTiers : ["100","150","250","350","500","600","850","1000","2000","5000"]
  },
  {
    locale : "de-DE",
    productKey : "prd-njdwnhvi",
    priceTiers : ["50","200","500","1000","3000"]
  },
  {
    locale : "en-US",
    productKey : "prd-njdwnhvi",
    priceTiers : ["100","225","675","1000"]
  },
  {
    locale: 'en-IE',
    productKey: 'prd-qdhwjxar',
    priceTiers: ['50', '100', '150', '250', '500', '1000', '1500', '2500', '5000']
  },
  {
    locale: 'de-DE',
    productKey: 'prd-qdhwjxar',
    priceTiers: ['50', '100', '150', '250', '500', '750', '1000', '1500', '2500', '5000']
  }
]

export const sliderProductsPROD = [
  {
    locale: "en-US",
    class: "BAG",
    productName: "Large Water-Resistant Lila Shopping Tote",
    status: "Active",
    productId: "bea00b7d-561b-48e0-9dea-639a75078687",
    productKey: "PRD-WOPGB0FZ", 
    productCode: "UDN",
    priceTiers : ["1","50","100","150","250","350","500","750","1000","1500","2500"]
  },
  {
    locale: "en-US",
    class: "BAG",
    productName: "Budget Shopper Tote",
    status: "Active",
    productId: "52c0ca0c-45e1-4b5a-9e90-d6bb7eb36851",
    productKey: "PRD-UQ0NIGVX",
    productCode: "UDJ",
    priceTiers : ["1","50","100","150","250","350","500","750","1000","1500","2500"]
  },
  {
    locale: "en-US",
    class: "BAG",
    productName: "Tote Bag with Patriotic Flag",
    status: "Active",
    productId: "57df70e9-3af7-40d6-9947-530b1fedf6e7",
    productKey: "PRD-MHGPRSLN",
    productCode: "UFG",
    priceTiers : ["1","50","100","150","250","350","500","1000","1500","5000"]
  },
  {
    locale: "en-US",
    class: "BAG",
    productName: "Budget Shopper Tote with Gray Trim",
    status: "Active",
    productId: "0f4c5064-ba88-49d7-9a50-ae2b5327570a",
    productKey: "PRD-HM0SMMKD",
    productCode: "UAH",
    priceTiers : ["1","50","100","150","250","350","500","750","1000","1500","2500"]
  },
  {
    locale: "en-US",
    class: "BAG",
    productName: "Everyday Commuter Drawstring Backpack",
    status: "Not Marketed",
    productId: "964af516-43e7-45eb-803c-2ce0b95b49e0",
    productKey: "PRD-9XVS1EKM",
    productCode: "UDY",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "BAG",
    productName: "Large Wave Patterned Shopping Bag",
    status: "Active",
    productId: "a00d452e-f36f-4076-b8bf-80b7bfbf8ecc",
    productKey: "PRD-PRG5EAAJ",
    productCode: "UAD",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "BAG",
    productName: "Large Shopping Tote",
    status: "Active",
    productId: "bea00b7d-561b-48e0-9dea-639a75078687",
    productKey: "PRD-WOPGB0FZ",
    productCode: "UDN",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "BAG",
    productName: "Budget Shopper Tote",
    status: "Active",
    productId: "52c0ca0c-45e1-4b5a-9e90-d6bb7eb36851",
    productKey: "PRD-UQ0NIGVX",
    productCode: "UDJ",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "BAG",
    productName: "UDJ Bag with Gray Color Block",
    status: "Active",
    productId: "0f4c5064-ba88-49d7-9a50-ae2b5327570a",
    productKey: "PRD-HM0SMMKD",
    productCode: "UAH",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "LPP",
    productName: "Metal Paragon Pen",
    status: "Active",
    productId: "2e21a6a9-0722-41b0-a89f-aeea7cb5ef11",
    productKey: "PRD-LE79WK3Z",
    productCode: "LPG",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "LPP",
    productName: "Metal Bright Soft Touch Diamond Stylus Pen",
    status: "Active",
    productId: "2daf98a1-20eb-4fbc-890b-ee0ce5a2fbf2",
    productKey: "PRD-ER13II9U",
    productCode: "MMV",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "LPP",
    productName: "Metal Soft Touch Diamond Stylus Pen",
    status: "Active",
    productId: "8a5640e7-fecf-475c-aea9-3d9c8907d921",
    productKey: "PRD-NPTUHRUS",
    productCode: "MNH",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "LPP",
    productName: "Metal Alpha Soft Touch Pen With Stylus",
    status: "Active",
    productId: "f02d81ab-9e53-4227-bf5e-2e61ea32b12a",
    productKey: "PRD-X1OII8HZ",
    productCode: "LNS",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "LPP",
    productName: "Bright Soft Touch Diamond Stylus Pen with Gel Ink",
    status: "Active",
    productId: "73493588-f6c4-49b8-a36a-ec74b9413406",
    productKey: "PRD-TYZSLAFU",
    productCode: "MRL",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "LPP",
    productName: "Metal Triangle Viera Pen with Rose Gold Trim",
    status: "Active",
    productId: "93c45e65-daf7-4028-968d-a6bbe8dc1396",
    productKey: "PRD-NV3WYNAB",
    productCode: "MRC",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "LPP",
    productName: "LPU pen with rose gold trim and satin finish",
    status: "Active",
    productId: "dedc5f8c-3d9c-4be2-b9b0-d09304f800f6",
    productKey: "PRD-ZZBSTYC7",
    productCode: "MRQ",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "LPP",
    productName: "Mineral Metal Alpha Soft Touch Stylus Pen with Rose Gold Trim",
    status: "Active",
    productId: "8f2f3b2b-ed1d-4425-8785-d21bf48fae2e",
    productKey: "PRD-GUKEUJF7",
    productCode: "MOI",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "LPP",
    productName: "MNH in Mineral colors with Rose Gold Trim",
    status: "Active",
    productId: "1814ac75-0720-4728-ba0c-7cac4c32c0a5",
    productKey: "PRD-P148FQYR",
    productCode: "MRR",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "LPP",
    productName: "Rainbow Metal Alpha Soft Touch Pen with Stylus",
    status: "Active",
    productId: "450586bb-ca2b-48e6-b096-6268487ac120",
    productKey: "PRD-ZPEJMJHH",
    productCode: "LMQ",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "LPP",
    productName: "Metal Soft Touch Maya Stylus Tip Pen",
    status: "Active",
    productId: "63b98202-9ceb-4c67-84f1-e7a340db0f9f",
    productKey: "PRD-2XUZK324",
    productCode: "LMN",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "LPP",
    productName: "Metal Alpha Soft Touch Pen with Stylus & Rose Gold Trim",
    status: "Active",
    productId: "1c57dfd3-1994-44d8-9a89-dca05319fe19",
    productKey: "PRD-9IRDWW5S",
    productCode: "MOV",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "LPP",
    productName: "MOV with Korean Gel Refill",
    status: "Active",
    productId: "99e29971-f428-4e12-a30d-cc4ef73efcf4",
    productKey: "PRD-7K4QKTEJ",
    productCode: "MRY",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "LPP",
    productName: "Metal Soft Touch Paragon Pen",
    status: "Active",
    productId: "d4a0cf30-9136-4ea4-bdce-a7a2d5713161",
    productKey: "PRD-WO4MQBW9",
    productCode: "LPU",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "LPP",
    productName: "Engraved Bright Diamond Stylus Pen",
    status: "Active",
    productId: "2daf98a1-20eb-4fbc-890b-ee0ce5a2fbf2",
    productKey: "PRD-ER13II9U",
    productCode: "MMV",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "LPP",
    productName: "Engraved Soft Touch Diamond Stylus Pen",
    status: "Active",
    productId: "8a5640e7-fecf-475c-aea9-3d9c8907d921",
    productKey: "PRD-NPTUHRUS",
    productCode: "MNH",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "LPP",
    productName: "Bright Soft Touch Diamond Stylus Gel Pen",
    status: "Not Marketed",
    productId: "73493588-f6c4-49b8-a36a-ec74b9413406",
    productKey: "PRD-TYZSLAFU",
    productCode: "MRL",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "LPP",
    productName: "Triangle Viera Pen with Rose Gold Trim",
    status: "Active",
    productId: "93c45e65-daf7-4028-968d-a6bbe8dc1396",
    productKey: "PRD-NV3WYNAB",
    productCode: "MRC",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "LPP",
    productName: "Mineral Soft Touch Diamond Stylus Pen with Rose Gold Trim",
    status: "Active",
    productId: "1814ac75-0720-4728-ba0c-7cac4c32c0a5",
    productKey: "PRD-P148FQYR",
    productCode: "MRR",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "LPP",
    productName: "Bright Soft Touch Maya Pen and Stylus Tip",
    status: "Active",
    productId: "63b98202-9ceb-4c67-84f1-e7a340db0f9f",
    productKey: "PRD-2XUZK324",
    productCode: "LMN",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "LPP",
    productName: "Engraved Paragon Pen",
    status: "Active",
    productId: "2e21a6a9-0722-41b0-a89f-aeea7cb5ef11",
    productKey: "PRD-LE79WK3Z",
    productCode: "LPG",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "LPP",
    productName: "Engraved Alpha Soft Touch Pen with Stylus®",
    status: "Active",
    productId: "f02d81ab-9e53-4227-bf5e-2e61ea32b12a",
    productKey: "PRD-X1OII8HZ",
    productCode: "LNS",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "LPP",
    productName: "Satin Finish Paragon Pen with Rose Gold Trim",
    status: "Not Marketed",
    productId: "dedc5f8c-3d9c-4be2-b9b0-d09304f800f6",
    productKey: "PRD-ZZBSTYC7",
    productCode: "MRQ",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "LPP",
    productName: "Mineral Alpha Soft Touch Stylus Pen with Rose Gold Trim",
    status: "Active",
    productId: "8f2f3b2b-ed1d-4425-8785-d21bf48fae2e",
    productKey: "PRD-GUKEUJF7",
    productCode: "MOI",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "LPP",
    productName: "Bright Alpha Soft Touch Pen with Stylus",
    status: "Active",
    productId: "450586bb-ca2b-48e6-b096-6268487ac120",
    productKey: "PRD-ZPEJMJHH",
    productCode: "LMQ",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "LPP",
    productName: "Alpha Soft Touch Stylus Pen with Rose Gold Trim",
    status: "Active",
    productId: "1c57dfd3-1994-44d8-9a89-dca05319fe19",
    productKey: "PRD-9IRDWW5S",
    productCode: "MOV",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "LPP",
    productName: "Alpha Soft Touch Gel Pen with Rose Gold Trim",
    status: "Active",
    productId: "99e29971-f428-4e12-a30d-cc4ef73efcf4",
    productKey: "PRD-7K4QKTEJ",
    productCode: "MRY",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "LPP",
    productName: "Elite Engraved Soft Touch Paragon Pen",
    status: "Active",
    productId: "d4a0cf30-9136-4ea4-bdce-a7a2d5713161",
    productKey: "PRD-WO4MQBW9",
    productCode: "LPU",
    priceTiers : ["50","100","150","250","350","500","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "BAG",
    productName: "Morris Tote",
    status: "Active",
    productId: "d07627ce-2b50-4eda-ada6-80cd968b7888",
    productKey: "PRD-HYA4ZBFT",
    productCode: "UEG",
    priceTiers : ["75","100","150","250","350","500","750","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "BAG",
    productName: "Morris Tote",
    status: "Active",
    productId: "d07627ce-2b50-4eda-ada6-80cd968b7888",
    productKey: "PRD-HYA4ZBFT",
    productCode: "UEG",
    priceTiers : ["50","75","100","150","250","350","500","1000","1500","2000","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "BAG",
    productName: "Drawstring backpack",
    status: "Active",
    productId: "7e9521fc-bfde-4f2c-8c9a-a405ab83a011",
    productKey: "PRD-8ESSBSXY",
    productCode: "UAG",
    priceTiers : ["75","100","150","250","500","750","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "BAG",
    productName: "Wave Patterned Large Shopping Tote Bag",
    status: "Active",
    productId: "a00d452e-f36f-4076-b8bf-80b7bfbf8ecc",
    productKey: "PRD-PRG5EAAJ",
    productCode: "UAD",
    priceTiers : ["75","100","150","250","500","750","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "GPN",
    productName: "Contour Pen",
    status: "Active",
    productId: "2531441c-c6dc-4b29-885d-45773eca4f50",
    productKey: "PRD-C7QKZ9WF",
    productCode: "CTR",
    priceTiers : ["100","150","250","350","500","750","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "GPN",
    productName: "Business Image Colourama Pen",
    status: "Disabled",
    productId: "c92f21b6-1a90-41a8-bd99-05b1a16d8498",
    productKey: "PRD-IBCO8RSH",
    productCode: "PGW",
    priceTiers : ["100","150","250","350","500","750","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "GPN",
    productName: "Design Wrap Contour Pen",
    status: "Active",
    productId: "2531441c-c6dc-4b29-885d-45773eca4f50",
    productKey: "PRD-C7QKZ9WF",
    productCode: "CTR",
    priceTiers : ["100","150","250","350","500","750","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "GPN",
    productName: "Business Image Colorama Pen",
    status: "Phase-out",
    productId: "c92f21b6-1a90-41a8-bd99-05b1a16d8498",
    productKey: "PRD-IBCO8RSH",
    productCode: "PGW",
    priceTiers : ["100","150","250","350","500","750","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "PPP",
    productName: "Rainbow Soft Touch Camilla Stylus Pen",
    status: "Active",
    productId: "e2149edd-9f5a-482b-a6f5-a61314368374",
    productKey: "PRD-B5EVONYT",
    productCode: "PYM",
    priceTiers : ["100","150","250","350","500","750","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "PPP",
    productName: "Soft Touch Gel cap w/Plastic Clip (Low cost ABR)",
    status: "Active",
    productId: "2dabf850-439e-47f8-a85d-4966cbc77b1e",
    productKey: "PRD-79WGRMYD",
    productCode: "AGP",
    priceTiers : ["100","150","250","350","500","750","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "PPP",
    productName: "Soft Touch Athos Gel Pen",
    status: "Active",
    productId: "bd4b8522-4997-45ac-8a66-20b15003a9d3",
    productKey: "PRD-5MHQXY7F",
    productCode: "PFP",
    priceTiers : ["100","150","250","350","500","750","1000","1500","2500","5000"]
  },
  {
    locale: "de-DE",
    class: "PPP",
    productName: "ACO Rose Gold Trim",
    status: "Active",
    productId: "b7b66f3c-5c2f-4d8f-a7b8-aaba372af634",
    productKey: "PRD-07LUM0GK",
    productCode: "AGU",
    priceTiers : ["100","150","250","350","500","750","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "PPP",
    productName: "Full Color Bright Soft Touch Hughes Gel Pen",
    status: "Active",
    productId: "2dabf850-439e-47f8-a85d-4966cbc77b1e",
    productKey: "PRD-79WGRMYD",
    productCode: "AGP",
    priceTiers : ["100","150","250","350","500","750","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "PPP",
    productName: "Soft Touch Athos Gel Pen",
    status: "Active",
    productId: "bd4b8522-4997-45ac-8a66-20b15003a9d3",
    productKey: "PRD-5MHQXY7F",
    productCode: "PFP",
    priceTiers : ["100","150","250","350","500","750","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "BAG",
    productName: "Damon Drawstring Backpack",
    status: "Phase-out",
    productId: "7e9521fc-bfde-4f2c-8c9a-a405ab83a011",
    productKey: "PRD-8ESSBSXY",
    productCode: "UAG",
    priceTiers : ["100","150","250","350","500","750","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "PPP",
    productName: "Bright Soft Touch Camilla Stylus Pen",
    status: "Active",
    productId: "e2149edd-9f5a-482b-a6f5-a61314368374",
    productKey: "PRD-B5EVONYT",
    productCode: "PYM",
    priceTiers : ["100","200","300","500","800","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "PPP",
    productName: "Full Color Soft Touch Basilia Stylus Pen with Rose Gold Trim",
    status: "Active",
    productId: "b7b66f3c-5c2f-4d8f-a7b8-aaba372af634",
    productKey: "PRD-07LUM0GK",
    productCode: "AGU",
    priceTiers : ["100","200","300","500","800","1000","1500","2500","5000"]
  },
  {
    locale: "en-US",
    class: "PPP",
    productName: "Color Block Raven Pen",
    status: "Active",
    productId: "4c5dca21-d4f4-4839-882b-67bd9d39a47e",
    productKey: "PRD-73IG6SOT",
    productCode: "ABG",
    priceTiers : ["250","350","500","750","1000","1250","1500","2500","5000","10000"]
  },
  {
    locale: "en-US",
    class: "PPP",
    productName: "Executive Cirrus Pen",
    status: "Active",
    productId: "0198758e-f37d-49a7-bd9e-dff880219072",
    productKey: "PRD-05OLASOO",
    productCode: "PCT",
    priceTiers : ["250","350","500","750","1000","1250","1500","2500","5000","10000"]
  }
]